import type { OrganisationInterface } from '@/types'

import { ORGANISATIONS_DEFAULT_PAGE_SIZE } from '../OrganisationsSearch.config'
import cn from '../OrganisationsSearch.module.scss'
import OrganisationSuggestion from '../OrganisationSuggestion/OrganisationSuggestion'

interface OrganisationsSearchResultsProps {
  organisations: OrganisationInterface[]
  totalCount: number
  search: string
  isFocused: boolean
  onChoose: (organisation: OrganisationInterface) => void
  onShowMore: () => void
}

function OrganisationsSearchResults({
  organisations,
  totalCount,
  search,
  isFocused,
  onChoose,
  onShowMore,
}: OrganisationsSearchResultsProps) {
  if (!search) return null

  if (!organisations.length) {
    if (!isFocused) return null
    return (
      <div className={cn.dropdownListContainer}>
        <div className={cn.list}>
          <div className={cn.listItem}>Ничего не найдено</div>
        </div>
      </div>
    )
  }

  return (
    <div className={cn.dropdownListContainer}>
      <div className={cn.list}>
        {organisations.map((organisation) => (
          <div
            className={cn.listItem}
            key={organisation.id}
            onClick={() => onChoose(organisation)}
          >
            <OrganisationSuggestion organisation={organisation} />
          </div>
        ))}
        {totalCount > ORGANISATIONS_DEFAULT_PAGE_SIZE && (
          <div className={cn.listItem} onClick={onShowMore}>
            Показать еще...
          </div>
        )}
      </div>
    </div>
  )
}

export default OrganisationsSearchResults
